import storePin from "./assets/pin-ecco.png";
import partnerPin from "./assets/pin-partner.png";
import storePinSelected from "./assets/pin-ecco-selected.png";
import parcelShopPin from "./assets/pin-parcel-shop.png";
import parcelShopPinSelected from "./assets/pin-parcel-shop-selected.png";
import cluster from "./assets/cluster.png";
import clientPin from "./assets/pin-retailer.png";
import zoomIn from "./assets/plus.png";
import zoomOut from "./assets/minus.png";
import zoomInSquare from "./assets/plus-square.png";
import zoomOutSquare from "./assets/minus-square.png";
import storeListed from "./assets/store-listed.png";
import storeSelected from "./assets/store-selected.png";

export const icon = {
    partnerPin,
    storePin,
    storePinSelected,
    storeListed,
    storeSelected,
    parcelShopPin,
    parcelShopPinSelected,
    cluster,
    clientPin,
    zoomIn,
    zoomOut,
    zoomInSquare,
    zoomOutSquare,
};
